module.exports = __webpack_public_path__ + "static/media/Background2@2x.79e389fe.png";